module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/feature1@2x.1999a4b.jpg";